<template>
  <div>
    <InterestShowFields
      v-if="interestFieldOptions && interestFieldOptions.length"
      ref="InterestShowFields"
      v-model="isShowFieldPopup"
      :interest-field-options="interestFieldOptions"
      :form-data="formData"
      :params="{
        uuid: params.uuid,
        insuredAge: params.insuredAge
      }"
      @addAndTakeConfirm="addAndTakeConfirm"
      @confirm="fieldConfirm"
      @save="type => $emit('save', type)"
    />

    <bxs-bottom-sheets
      v-model="popupConfig.visible"
      class="interest-att-bottom-sheets"
      :title="popupConfig.title"
      height="middle"
      :prevent-scroll-through="true"
    >
      <AddAndTake
        v-if="popupConfig.visible"
        ref="AddAndTake"
        :type="popupConfig.type"
        :result-data="{
          uuid: params.uuid,
          insuredAge: params.insuredAge,
          accountData: popupConfig.data
        }"
        :params="{
          productKey: formData.productId,
          insuranceKey: popupConfig.insuranceKey,
          bonus: values.bonus,
          takeType: values.takeType,
          rate: values.rateIndex === -1 ? formData.customRate : values.rate,
        }"
        @confirm="addAndTakeConfirm"
      />
    </bxs-bottom-sheets>
  </div>
</template>
<script>
import { get as _get } from 'lodash'
import { BottomSheets } from 'bxs-ui-vue';
import { AddAndTake } from 'bxs-tools-ui'
import InterestShowFields from './interest-show-fields.vue'

export default {
  components: {
    [BottomSheets.name]: BottomSheets,
    AddAndTake,
    InterestShowFields,
  },
  props: {
    interestFieldOptions: {
      type: Array,
      default: () => []
    },
    formData: {
      type: Object,
      default: () => ({})
    },
    params: {
      type: Object,
      default: () => ({})
    },
  },
  data () {
    return {
      values: null,
      popupConfig: this.initPopupConfig(),
    }
  },
  computed: {
    isShowFieldPopup () {
      return this.formData.formValues.isShowFieldPopup
    }
  },
  watch: {
    'formData.formValues': {
      deep: true,
      immediate: true,
      handler (v) {
        this.values = v
      }
    },
    'popupConfig.visible': {
      immediate: true,
      deep: true,
      handler (v) {
        if (v) {
          return
        }
        const ref = this.$refs.AddAndTake;
        if (!ref) {
          return;
        }
        if (ref.subName === 'Form') {
          this.popupConfig.visible = true;
          ref.goToTable();
        }
      }
    }
  },
  methods: {
    fieldConfirm (data) {
      this.$emit('update', data)
    },
    initPopupConfig() {
      return {
        visible: false,
        title: '',
        type: ''
      }
    },
    // WYJHS-959 追加领取/减保领取入口变更，为简化改动未将 <AddAndTake> 移入父组件。
    // @external 该方法被外部直接调用
    openAddAndTakePicker (item) {
      const { formData } = this
      const ADD_TAKE_TITLES = {
        addAndTake: '追加领取',
        add: '追加保费',
        take: '部分领取',
        reduceBaof: '减保领取'
      }
      const type = item.key === 'drawData' ? 'reduceBaof' : formData.addAndTakeData.accountPart
      const insuranceKey = type === 'reduceBaof' ? formData.drawInsuranceId : formData.accountInsuranceId
      this.popupConfig = {
        visible: true,
        title: ADD_TAKE_TITLES[type],
        type,
        insuranceKey,
        data: type === 'reduceBaof' ? {
          accountPart: 'take',
          addAndTakeData: formData.drawData || []
        } : formData.addAndTakeData
      }
    },
    addAndTakeConfirm(data) {
      const { formData, values, interestFieldOptions, popupConfig } = this
      const { type, accountData, interestData } = data
      const isReduceBaof = (type || popupConfig.type) === 'reduceBaof'
      const _rateField = interestFieldOptions.find(e => e.key === 'rate')
      const _rateOptionIndex = _get(_rateField, 'options', []).findIndex(o => o.value === interestData.rate)
      const _rateIndex = _rateOptionIndex > -1 ? _rateOptionIndex : 3
      const _updateData = {
        [isReduceBaof ? 'drawData' : 'addAndTakeData']: isReduceBaof ? accountData.addAndTakeData : accountData,
        ...interestData,
        rateIndex: _rateIndex,
        [isReduceBaof ? 'drawFlag' : 'addAndTakeFlag']: true,
        displayFields: values.displayFields
      }
      this.$emit('update', _updateData)
      if (!isReduceBaof) {
        this.$emit('update-account-map', {
          productId: formData.productId,
          accountInsuranceId: formData.accountInsuranceId,
          addAndTakeData: accountData.addAndTakeData,
        })
      }
      this.popupConfig = this.initPopupConfig()
    }
  }
}
</script>
<style>
.interest-att-bottom-sheets .bxt-aat-table-content-cell {
  box-sizing: content-box!important;
}
</style>
